import { RouteListGetter } from 'App';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { AppRoutes } from 'config/app-routes';

const getKnowledgeBaseRoutes: RouteListGetter = (_, isExperimentEnabled) => {
  if (!isExperimentEnabled('pages.knowledgeBase.enabled')) return <></>;
  // const KnowledgeBasePage = lazily('knowledge-base');
  const KnowledgeBasePage = () => {
    return <Navigate to={AppRoutes.CONSENT_DASHBOARD + '/knowledge-base'} />;
  };
  return <Route path={AppRoutes.knowledgeBase.index()} element={<KnowledgeBasePage />} />;
};

export default getKnowledgeBaseRoutes;
